/* eslint-disable no-unused-vars */
import { Box, Modal } from "@mui/material";
import React from "react";
import Close from "../../Components/Icons/Close";
import cssClasses from "./ViewDetails.module.css";
import { makeStyles } from "@mui/styles";
import { useSelector } from "react-redux";
import TimeAgo from "javascript-time-ago";
import en from "javascript-time-ago/locale/en.json";
import ShowQrCode from "../../Subcomponents/ShowQrCode/ShowQrCode";
import { numberWithCommas } from "../../Assets/Common/CommonFunctions";

const useStyles = makeStyles((theme) => ({
	tokenName: {
		fontFamily: "Inter-Medium",
		fontStyle: "normal",
		fontWeight: "500",
		fontSize: "2rem",
		lineHeight: "3rem",
		color: "#000000",
	},
	wrapperIcons: {
		display: "flex",
		flexDirection: "row",
		alignItems: "flex-start",
		justifyContent: "space-around",
		marginBottom: "2rem",
		position: "relative",
	},
	closeIcon: {
		cursor: "pointer",
		position: "absolute",
		right: "1.7rem",
		top: "1.7rem",
	},
	title: {
		fontFamily: "Inter-Medium",
		fontStyle: "normal",
		fontWeight: "500",
		fontSize: "1.8rem",
		lineHeight: "2.8rem",
		color: "#101828",
		marginBottom: "0.8rem",
	},
	subTitle: {
		fontFamily: "Inter-Medium",
		fontStyle: "normal",
		fontWeight: "500",
		fontSize: "1.4rem",
		lineHeight: "2rem",
		color: "#667085",
		marginBottom: "3.2rem",
	},
	labelCard: {
		fontFamily: "Inter-Medium",
		fontStyle: "normal",
		fontWeight: "500",
		fontSize: "1.4rem",
		lineHeight: "2rem",
		color: "#667085",
		marginBottom: "3.2rem",
	},
	labelValue: {
		fontFamily: "Inter-Medium",
		fontStyle: "normal",
		fontWeight: "500",
		fontSize: "1.4rem",
		lineHeight: "2rem",
		color: "#667085",
		marginBottom: "3.2rem",
	},
	wrapperButtons: {
		display: "flex",
		flexDirection: "row",
		alignItems: "center",
		justifyContent: "space-between",
		columnGap: "1.2rem",
	},
	backArrow: {
		verticalAlign: "middle",
	},
}));
const ViewDetails = ({ open, handleClose, returnRes, data }) => {
	const classes = useStyles();
	let loggedInUser = {};
	loggedInUser = useSelector((state) => state.Auth.user);
	TimeAgo.setDefaultLocale(en.locale);
	TimeAgo.addLocale(en);
	const qrData = {
		amount: data.amount,
		eventImage: data.eventId.bannerImgUrl,
		// projectName: "Novaglobal",
		tokenDisplayNumber: data.tokenNumber,
		eventName: data.eventId.title,
		tokenTitle: data.eventTokenId.tokenId.name,
		eventDateTime:
			new Date(data.eventId.startDateTime).toDateString() +
			", " +
			new Date(data.eventId.startDateTime).toLocaleTimeString([], {
				hour: "2-digit",
				minute: "2-digit",
			}),
		// projectLocation: "Pune",
		tokenIssued:
			new Date(data.created_at).toDateString() +
			", " +
			new Date(data.created_at).toLocaleTimeString([], {
				hour: "2-digit",
				minute: "2-digit",
			}),
		tokenAmount: numberWithCommas(data.amount),
		paymentId: data.paymentId,
		qrCode: data.qrUrl,
		paidAmount: data.paidAmount,
	};
	function closeModal() {
		handleClose();
	}

	return (
		<Modal
			open={open}
			onClose={(_, reason) => {
				if (reason !== "backdropClick") {
					closeModal();
				}
			}}
			aria-labelledby="modal-modal-title"
			aria-describedby="modal-modal-description"
			sx={[
				{
					".MuiBackdrop-root": {
						background: "rgba(52, 64, 84, 0.7)",
					},
				},
			]}
			disableAutoFocus={true}
		>
			<Box className={cssClasses.modalWrapper}>
				<div className={cssClasses.wrapperHeader}>
					<span className={classes.closeIcon} onClick={closeModal} tabIndex={0}>
						<Close width={"1.2rem"} height={"1.2rem"} />
					</span>
					<div>Token Details</div>
				</div>
				<div className={cssClasses.wrapperContent}>
					<ShowQrCode qrData={qrData} />
					{/* <div className={cssClasses.cardHeader}>
                        <div className={cssClasses.tokenNumWrap}>
                            <span>{data.tokenNumber}</span>
                        </div>
                        <div className={cssClasses.tokenStatus}>
                            {data.paidAmount > 0 && data.paidAmount < data.amount &&
                                <LeadStatusChip
                                    label={'Partial'}
                                    icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                                    style={{ color: "#B54708", backgroundColor: "#FFFAEB" }}
                                ></LeadStatusChip>
                            }
                            {data.paidAmount > 0 && data.paidAmount === data.amount &&
                                <LeadStatusChip
                                    label={'Complete'}
                                    icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                                    style={{ color: "#027A48", backgroundColor: "#ECFDF3" }}
                                ></LeadStatusChip>
                            }
                            {data.paidAmount === 0 &&
                                <LeadStatusChip
                                    label={'Pending'}
                                    icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                                    style={{ color: "#B42318", backgroundColor: "#FEF3F2" }}
                                ></LeadStatusChip>
                            }
                        </div>
                        <div className={cssClasses.tokenLastUpdate}>
                            <ReactTimeAgo
                                style={{ fontSize: "1.2rem" }}
                                date={data?.last_updated_at ?? data?.created_at}
                                locale="en-US"
                            />
                        </div>
                    </div>
                    <div className={cssClasses.cardDetails}>
                        <div className={cssClasses.tokenDetails}>
                            <div className={cssClasses.tokenData}>
                                <span>{data.eventTokenId.tokenId.name}</span>
                            </div>
                            <div className={cssClasses.tokenData}>
                                <span>{data.eventTokenId.tokenId.inventoryTypeId.type} |{" "}</span>
                                <span>{data.eventId.title}</span>
                            </div>
                            <div className={cssClasses.tokenData}>
                                <span>Bought on : </span>
                                <span>{new Date(data.created_at).toDateString()}, {new Date(data.created_at).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}</span>

                            </div>
                        </div>
                        <div className={cssClasses.cardFooter}>
                            <div className={cssClasses.totalAmt}>
                                <span>Total Amount : </span>
                                <span>₹{' '}{numberWithCommas(data.amount)}</span>
                            </div>
                            <div className={cssClasses.paidAmt}>
                                <span>Paid Amount : </span>
                                <span>₹{' '}{numberWithCommas(data.paidAmount)}</span>
                            </div>
                        </div>
                    </div> */}
				</div>
				{/* <div className={cssClasses.wrapperFooter}>
                    <Button
                        style={{
                            color: "#ffffff",
                            backgroundColor: "#155EEF",
                            fontSize: "1.6rem",
                            lineHeight: "2.4rem",
                            width: "auto"
                        }}
                        btnName={"OK"}
                        clicked={() => {
                            closeModal();
                        }}
                    />
                </div> */}
			</Box>
		</Modal>
	);
};

export default ViewDetails;
